__webpack_require__.p = "/kannada-typing/_next/";